import axios from 'axios';
import Auth0 from '../../../../../store/actions/auth/Auth';
import { getStoredFile, clearFileStore } from '../../../../../components/FileUpload/FileUpload';
import handleError from '../../../../../components/FormHelpers/handleError';


const MAX_FILE_SIZE_MB = 300;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1000 * 1000;

const postFile = (file, deliveryId) => {
  let fileToBeSent = new FormData();
  fileToBeSent.append("file", file, file.name);

  return axios.post(`/api/files?deliveryId=${deliveryId}`, fileToBeSent, {
    onUploadProgress: (progressEvent) => {
      console.log((100 * progressEvent.loaded) / progressEvent.total + '%');
    },
    headers: { 
      'Content-Type': 'multipart/form-data', 
      "Authorization": `Bearer ${Auth0.getAccessToken()}` 
    }
  });
};
  
const validateFile = (file) => {
  return new Promise((resolve, reject) => {
    if (file.size > MAX_FILE_SIZE) {
      console.error("File size is too big");
      return reject(new Error("File size is too big"));
    }
    return resolve();
  });
};

const submitForm = async (values, navigate, setError) => {
  let req1 = {};

  const arrayToPost = {
    ...values,
    numberOfFiles: values.fileDrop.length
  };
  delete arrayToPost['fileDrop'];
  
  try {
    req1 = await axios.post(`/api/admin/deliveries/fromCustomer`, {
      ...arrayToPost
    }, {
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
    });
  } catch (err) {
    if (setError) {
      setError('root', {
        type: 'manual',
        message: err.response?.data?.message || 'An error occurred'
      });
    }
    throw err;
  }

  // Retrieve actual File objects from the fileStore using metadata
  let promises = [];

  values.fileDrop.forEach((fileMeta) => {
    const file = getStoredFile(fileMeta.fileId);
    if (!file) {
      console.error(`File not found in store: ${fileMeta.fileName}`);
      promises.push(Promise.reject(new Error(`File not found: ${fileMeta.fileName}`)));
      return;
    }
    promises.push(
      validateFile(file).then(() => postFile(file, req1.data.deliveryId))
    );
  });

  try {
    await Promise.all(promises);
    
    await axios.post(
      `/api/admin/deliveries/fromCustomer/${req1.data.deliveryId}/uploadComplete`, 
      {}, 
      {
        headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
      }
    );
    
    clearFileStore();
    navigate('/uploadconfirmed');
  } catch (err) {
    if (setError) {
      handleError(err.response, setError);
    }
    throw err;
  }
};

export default submitForm;